export type CreateClientRequestHeadersOptions = {
  getStoredTenantId: () => string | null;
  authHeaders: () => Record<string, string>;
  /** BH: siempre envía X-Tenant-Id. FM: omite si no hay tenant. */
  alwaysIncludeTenantHeader: boolean;
  /** Usado cuando alwaysIncludeTenantHeader y no hay tenant explícito (BH). */
  defaultTenantId?: string;
};

export function createClientRequestHeaders(opts: CreateClientRequestHeadersOptions) {
  return function clientRequestHeaders(tenantId?: string | null): Record<string, string> {
    const stored = opts.getStoredTenantId();
    const tid = tenantId ?? stored ?? opts.defaultTenantId ?? null;

    if (opts.alwaysIncludeTenantHeader) {
      const headerTenant = tid ?? opts.defaultTenantId ?? "";
      return { "X-Tenant-Id": headerTenant, ...opts.authHeaders() };
    }

    return { ...(tid ? { "X-Tenant-Id": tid } : {}), ...opts.authHeaders() };
  };
}
